// extracted by mini-css-extract-plugin
export default {"gridHead":"HistoryBillingHead_gridHead__km2st","headCell":"HistoryBillingHead_headCell__Le5AA"};